import { render, staticRenderFns } from "./ReturnQuery.vue?vue&type=template&id=5160a4bb&scoped=true&"
import script from "./ReturnQuery.vue?vue&type=script&lang=js&"
export * from "./ReturnQuery.vue?vue&type=script&lang=js&"
import style0 from "./ReturnQuery.vue?vue&type=style&index=0&id=5160a4bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160a4bb",
  null
  
)

export default component.exports